import { Injectable } from '@angular/core';
import { PageableService } from '@pwc-bei/common';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { NotificationResource } from '../models/api/notification.resource';
import { NotificationModel } from '../models/notification.model';
import { YesNoEnum } from '../../../enums/yes-no.enum';

@Injectable({
  providedIn: 'root',
})
export class NotificationListService extends PageableService<
NotificationResource,
NotificationModel
> {
  protected baseUrl: string = environment.authUrl;
  protected endpoint: string = 'notification';

  constructor(http: HttpClient) {
    super(http);
  }

  count() {
    return this.http.get<any>(`${environment.authUrl}/${this.endpoint}/count`);
  }

  markAsRead(id: any) {
    return this.http.post<any>(
      `${environment.authUrl}/${this.endpoint}/${id}/mark`,
      null,
    );
  }

  convertResourceToModel(resource: NotificationResource): NotificationModel {
    return {
      ...resource,
      isRead: resource.isRead && resource.isRead === YesNoEnum.YES,
    };
  }

  convertModelToResource(model: NotificationModel): NotificationResource {
    return {
      ...model,
      isRead: model.isRead ? YesNoEnum.YES : YesNoEnum.NO,
    };
  }
}
